
import React from "react";
import history from "../../../history";
import { OpenAuction } from "../OpenAuction/OpenAuction";
import { OpenAuctionOrganizer } from "../OpenAuction/OpenAuctionOrganizer";
import { OpenAuctionParticipant } from "../OpenAuction/OpenAuctionParticipant";
import { OpenAuctionWithApplications } from "../OpenAuctionWithApplications/OpenAuctionWithApplications";
import { OpenAuctionWithApplicationsOrganizer } from "../OpenAuctionWithApplications/OpenAuctionWithApplicationsOrganizer";
import { OpenAuctionWithApplicationsParticipant } from "../OpenAuctionWithApplications/OpenAuctionWithApplicationsParticipant";
import { OpenAuctionWithDeposit } from "../OpenAuctionWithDeposit/OpenAuctionWithDeposit";
import { OpenAuctionWithDepositOrganizer } from "../OpenAuctionWithDeposit/OpenAuctionWithDepositOrganizer";
import { OpenAuctionWithDepositParticipant } from "../OpenAuctionWithDeposit/OpenAuctionWithDepositParticipant";
import { GetMyLotsPromise, GetLotsWithMyBetsPromise, GetLotsWithMyApplicationsPromise } from "./remote"
import { SearchLots } from "../../../Models/Filters/SearchLots"
import {
    TextInput2,
    TextArea2,
    Select2,
    Checkbox2,
} from "../../../Common/Form";
import {
    ISelectListItem
} from "../../../Common/SharedTypes"

import { TradeStatus, TradeStatusDescription } from "../../../enums/TradeStatus"

// данный функциональный компонент отвечает за отображение информации на страницу Моя активность.
// Он полностью рисует эту страницу вместе с боковым меню
export class MyActivityClass extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            Filters: this.initFilters(),
            listMyLots: null,
            listAllLotsWithMyBets: null,
            listAllLotsWithMyApplications: null,
            listFiltersLots: null,
            activeMenu: props.Item != '' ? props.Item : 'MyLots',
            isLoading: false // Флаг загрузки
        };
        this.currentMenu = null; // Для отслеживания текущего запроса
    }

    componentDidMount() {
        this.loadData();
    }

    // метод который должен быть вызван вначале, он фрмирует фильтры из значений props, если они пришли
    initFilters() {
        var filters = [];

        var keys = Object.keys(this.props);

        // фильтр по Id лота
        filters.push({
            FilterName: 'Id',
            FilterValue: this.props.Id,
            FilterType: 'number',
            FilterRef: React.createRef(),
            placeholder: "Введите № лота"
        });

        // фильтр по имени лота
        filters.push({
            FilterName: 'Name',
            FilterValue: this.props.Name,
            FilterType: 'string',
            FilterRef: React.createRef(),
            placeholder: "Введите название лота"
        });

        // фильтр по статусу лота
        filters.push({
            FilterName: 'LotTradeStatusId',
            FilterValue: this.props.LotTradeStatusId,
            FilterType: 'select',
            FilterRef: React.createRef(),
            placeholder: "Выберите статус лота",
            FilterValues: Object.keys(TradeStatus)
                .filter((value) => isNaN(Number(value)) === false)
                .map((x) => {
                    return {
                        Text: TradeStatusDescription[x],
                        Value: x,
                        Selected:
                            this.props.LotTradeStatusId != null ? this.props.LotTradeStatusId == parseInt(x) : false,
                        Disabled: false,
                    } as ISelectListItem;
                })
        });
        return filters;
    }

    // метод очищающий набор фильтров по лоту
    clearFilters() {
        var len = this.state.Filters.length;
        var filters = this.state.Filters;

        for (var i = 0; i < len; i++) {
            filters[i].FilterValue = null;
        }

        return filters;
    }

    onRemove = (id) => {
        console.log(id);
        switch (this.state.activeMenu) {
            case 'MyLots':
                this.setState({
                    ...this.state,
                    listMyLots: this.state.listMyLots.filter(lot => lot.Id != id)
                });
                break;
            case 'LotsWithMyBets':
                this.setState({
                    ...this.state,
                    listAllLotsWithMyBets: this.state.listAllLotsWithMyBets.filter(lot => lot.Id != id)
                });

                break;
            case 'LotsWithMyApplications':
                this.setState({
                    ...this.state,
                    listAllLotsWithMyApplications: this.listAllLotsWithMyApplications.filter(lot => lot.Id != id)
                });
        }
    }

    // метод загружающий с сервера данные согласно пункту меню
    loadData() {
        if (this.state.isLoading) return;

        this.setState({ ...this.state, isLoading: true });
        this.currentMenu = this.state.activeMenu;

        // используется для ограничения времени загрузки, предотвращает зависание пользовательского интерфейса
        const timeoutPromise = (promise, timeout = 60000) => {
            return Promise.race([
                promise,
                new Promise((_, reject) =>
                    setTimeout(() => reject(new Error('Request timed out')), timeout)
                )
            ]);
        };

        switch (this.state.activeMenu) {
            case 'MyLots':
                timeoutPromise(GetMyLotsPromise())
                    .then((result) => {
                        if (this.currentMenu !== 'MyLots') return;
                        console.log('MyActivity GetMyLotsPromise: ', result);
                        this.setState({
                            ...this.state,
                            listMyLots: result || [],
                            isLoading: false
                        });
                    })
                    .catch((error) => {
                        console.error('Error loading MyLots:', error);
                        this.setState({
                            ...this.state,
                            listMyLots: [],
                            isLoading: false
                        });
                    });

                break;
            case 'LotsWithMyBets':
                timeoutPromise(GetLotsWithMyBetsPromise())
                    .then((result) => {
                        if (this.currentMenu !== 'LotsWithMyBets') return;
                        console.log('MyActivity GetLotsWithMyBetsPromise: ', result);
                        this.setState({
                            ...this.state,
                            listAllLotsWithMyBets: result || [],
                            isLoading: false
                        });
                    })
                    .catch((error) => {
                        console.error('Error loading LotsWithMyBets:', error);
                        this.setState({
                            ...this.state,
                            listAllLotsWithMyBets: [],
                            isLoading: false
                        });
                    });

                break;
            case 'LotsWithMyApplications':
                timeoutPromise(GetLotsWithMyApplicationsPromise())
                    .then((result) => {
                        if (this.currentMenu !== 'LotsWithMyApplications') return;
                        console.log('MyActivity GetLotsWithMyApplicationsPromise: ', result);
                        this.setState({
                            ...this.state,
                            listAllLotsWithMyApplications: result || [],
                            isLoading: false
                        });
                    })
                    .catch((error) => {
                        console.error('Error loading LotsWithMyBets:', error);
                        this.setState({
                            ...this.state,
                            listAllLotsWithMyApplications: [],
                            isLoading: false
                        });
                    });
        }
    }

    // метод обновляющий url по значениям фильтров и активному меню
    updateUrl() {
        console.log('формирование url из filters = ', this.state.Filters);
        const url = "/MyActivity?Item=" + this.state.activeMenu + '&';
        const resultArr = [];

        this.state.Filters.map((filter) => {
            if (filter.FilterValue)
                resultArr.push(`${filter.FilterName}=${filter.FilterValue}`);
        });

        const queryString = `${url}${(resultArr.join("&"))}`;
        console.log(queryString);

        history.push(queryString);
    }

    // метод формирующий меню слева и возвращающий его html-представление
    menu() {
        // Стили для активного пункта
        const activeStyle = {
            color: '#B200FF',
            textDecoration: "underline"
        };

        // Стили для неактивного пункта
        const defaultStyle = {
            cursor: 'pointer'
        };

        return (
            <div className="col-auto gutter-col-10 sidebar-col" id="catalogFilterMain">
                {/* меню слева */}
                <div className="sidebar" id="mainFilterCatalog">
                    <div className="list">
                        <h4
                            onClick={(e) => { this.menuClick('MyLots') }}
                            style={this.state.activeMenu === 'MyLots' ? { ...defaultStyle, ...activeStyle } : defaultStyle}>
                            Мои лоты
                        </h4>
                    </div>
                    <div className="list">
                        <h4
                            onClick={(e) => { this.menuClick('LotsWithMyBets') }}
                            style={this.state.activeMenu === 'LotsWithMyBets' ? { ...defaultStyle, ...activeStyle } : defaultStyle}>
                            Лоты с моими ставками
                        </h4>
                    </div>
                    <div className="list">
                        <h4
                            onClick={(e) => { this.menuClick("LotsWithMyApplications") }}
                            style={this.state.activeMenu === 'LotsWithMyApplications' ? { ...defaultStyle, ...activeStyle } : defaultStyle}>
                            Лоты с моими заявками
                        </h4>
                    </div>
                    <div className="list">
                        <h4>Избранное</h4>
                        <ul>
                            <li>
                                <a href="#" onClick={(e) => { this.menuClick('MyFavoriteSeller') }}>Продавцы</a>
                            </li>
                            <li>
                                <a href="#" onClick={(e) => { this.menuClick('MyFavoriteLots') }}>Лоты</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }

    // метод вызывается по клике в меню слева
    menuClick(menu) {
        console.log('menu=', menu);
        this.setState({ ...this.state, activeMenu: menu, Filters: this.clearFilters() }, () => {
            this.loadData(); // Вызываем loadData после смены activeMenu
        });
    }

    // метод отвечающий за отображения списка лотов.
    showLots(list) {

        // У нас всего два списка: лоты созданные пользователем и лоты с участием его, но не созданные им.
        // фильтры у нас общие для обоих групп лотов. Поэтому если был примёнен фильтр, то отфильтрованные лоты должны быть в listFiltersLots
        var showLotsList = list; //this.state.listFiltersLots != null ? this.state.listFiltersLots : list;
        console.log('showLotsList list=', list);

        if (showLotsList != null)
            return (
                <React.Fragment>
                    {
                        showLotsList.map((lot, index) => {
                            const result = this.state.Filters.every((filter) =>
                                this.applyFilter(lot, filter)
                            );
                            if (result && lot.Page === "MyLots") {
                                if (lot.IsApplications) {
                                    return (
                                        <OpenAuctionWithApplicationsOrganizer key={lot.Id} lot={lot} onRemove={this.onRemove} />
                                    )
                                } else if (lot.IsLegal) {
                                    return (
                                        <OpenAuctionWithDepositOrganizer key={lot.Id} lot={lot} onRemove={this.onRemove} />
                                    )
                                } else {
                                    return (
                                        <OpenAuctionOrganizer key={lot.Id} lot={lot} onRemove={this.onRemove} />
                                    );
                                }
                            } else if (result && (lot.Page === "LotsWithMyBets") || lot.Page === "LotsWithMyApplications") {
                                if (lot.IsApplications) {
                                    return (
                                        <OpenAuctionWithApplicationsParticipant key={lot.Id} lot={lot} onRemove={this.onRemove} />
                                    )
                                } else if (lot.IsLegal) {
                                    return (
                                        <OpenAuctionWithDepositParticipant key={lot.Id} lot={lot} onRemove={this.onRemove} />
                                    )
                                } else {
                                    return (
                                        <OpenAuctionParticipant key={lot.Id} lot={lot} onRemove={this.onRemove} />
                                    );
                                }
                            }

                            return null;
                        })
                    }

                </React.Fragment>);
        else {

            //TODO! на время выполнения метода init необходимо показать лоадер
            return (<div>Загружаю данные...</div>);
        }
    }

    // метод который применяет фильтры к одному из списков лотов
    ApplyFiltersLot() {
        // получим значения фильтров
        var filters = this.state.Filters;

        filters.map((filter) => {
            filter.FilterValue = filter.FilterRef.current.getData();
        });

        console.log('filtersLots= ', filters);
        this.setState({
            ...this.state,
            Filters: filters
        });
    }

    // метод который применяет некоторый фильтр над некоторым переданным ему списокм объектов
    applyFilter(lot, filter) {

        if (filter.FilterValue) {
            if (filter.FilterType == 'number' || filter.FilterType == 'select') {
                if (lot[filter?.FilterName] == filter.FilterValue) return true;
            } else {
                if (lot[filter?.FilterName].toLowerCase().includes(filter.FilterValue.toLowerCase()))
                    return true;
            }
        } else {
            return true;
        }
    }

    // данный метод выводит набор фильтров по лотам
    FiltersForLots() {

        var components = [];
        var len = this.state.Filters.length;
        var filters = this.state.Filters;

        for (var i = 0; i < len; i++) {
            console.log('FiltersForLots', filters[i]);
            switch (filters[i].FilterType) {
                case 'string':
                    components.push(
                        <TextInput2
                            ref={filters[i].FilterRef}
                            label={"Название лота"}
                            name={filters[i].FilterName}
                            value={filters[i].FilterValue != null ? filters[i].FilterValue : null}
                            allowOnlyDecimals={false}
                            additionalLabelClass=""
                            required={true}
                            placeholder={filters[i].placeholder}
                            wrapInsideContainer={true}
                        ></TextInput2>
                    );
                    break;
                case 'number':
                    components.push(
                        <TextInput2
                            ref={filters[i].FilterRef}
                            label={"№ лота"}
                            name={filters[i].FilterName}
                            value={filters[i].FilterValue != null ? filters[i].FilterValue : null}
                            allowOnlyDecimals={true}
                            additionalLabelClass=""
                            required={true}
                            placeholder={filters[i].placeholder}
                            wrapInsideContainer={true}
                        ></TextInput2>
                    );
                    break;
                case 'select':
                    components.push(

                        <Select2
                            ref={filters[i].FilterRef}
                            containerClass=""
                            additionalClass=""
                            name={filters[i].FilterName}
                            required={true}
                            value={filters[i].FilterValue != null ? filters[i].FilterValue : null}
                            disabled={false}
                            optionLabel={"Все"}
                            options={filters[i].FilterValues}
                            label={filters[i].placeholder}
                        />
                    );
                    break;
            }
        }
        console.log('components = ', components);
        return (
            <div className="filters">
                {components.map((component, key) => (
                    <div className="filterFieldWrap" key={key}>
                        {component}
                    </div>
                ))}
                <button className="defaultPinkButton" onClick={(e) => { this.ApplyFiltersLot() }}>Поиск</button>
            </div>
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.Filters !== this.state.Filters || prevState.activeMenu !== this.state.activeMenu) {
            this.updateUrl();
        }
    }

    // соновной метод который рендерит весь компонент
    render() {
        console.log('render function');
        return (
            <React.Fragment>
                <div className="leftMenu">
                    {this.menu()}
                </div>

                <div className="rightContent">
                    {this.FiltersForLots()}
                    {/* основная рабочая область, где отображается список лотов */}
                    <div className="lotsList">
                        {/* если выбрано меню - Мои лоты */}
                        {(this.state.activeMenu === 'MyLots') && this.showLots(this.state.listMyLots)}

                        {/* если выбрано меню - Лоты с моими ставками */}
                        {(this.state.activeMenu === 'LotsWithMyBets') && this.showLots(this.state.listAllLotsWithMyBets)}

                        {/* если выбрано меню - Лоты с моими заявками */}
                        {(this.state.activeMenu === 'LotsWithMyApplications') && this.showLots(this.state.listAllLotsWithMyApplications)}
                    </div>
                </div>

            </React.Fragment>
        )
    }
}